<template>
  <base-button transparent size="sm" @click="$helpers.openSupportChat">
    <slot v-if="hasDefaultSlot"></slot>
    <div v-else>
      {{ $t('contact-by-chat-tech-problems') }}
    </div>
  </base-button>
</template>

<script>
export default {
  name: 'support-chat-button',
  components: {
    'base-button': () => import('@/components/base/buttons/BaseButton')
  },
  computed: {
    hasDefaultSlot () {
      return !!this.$slots.default
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/utils/SupportChatButton.vue